<template>
  <div v-loading="loading" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading"
    :style="{ height: tableHeight2 }" ref="tablebox" :class="['l-table', isPage ? 'l-table--haspagination' : '']">
    <!-- <div :style="{height: emptyHeight}"></div> -->
    <el-table :data="tableShowData" style="width: 100%" :height="tableHeight" :max-height="maxHeight" :size="size"
      :cell-style="cellStyle || { padding: '2px 0' }" :header-cell-style="headerCellStyle || { padding: '2px 0' }"
      :stripe="stripe" :border="border" :fit="fit" :show-header="showHeader"
      :highlight-current-row="highlightCurrentRow || singleSelect" :current-row-key="currentRowKey" :row-key="rowKey"
      :row-class-name="rowClassName" :cell-class-name="cellClassName" :header-row-class-name="headerRowClassName"
      :header-cell-class-name="headerCellClassName" :default-expand-all="defaultExpandAll"
      :expand-row-keys="expandRowKeys" :default-sort="defaultSort" :tooltip-effect="tooltipEffect"
      :show-summary="showSummary" :sum-text="sumText" :summary-method="getSummaries" :span-method="spanMethod"
      :select-on-indeterminate="selectOnIndeterminate" :indent="indent" :lazy="lazy" :load="load"
      :tree-props="treeProps" :row-style="rowStyle" @select="handleSelect" @select-all="handleSelectAll"
      @selection-change="selectionChange" @cell-mouse-enter="cellMouseEnter" @cell-mouse-leave="cellMouseLeave"
      @cell-click="cellClick" @cell-dblclick="cellDblclick" @row-click="rowClick" @row-contextmenu="rowContextmenu"
      @row-dblclick="rowDblclick" @header-click="headerClick" :header-row-style="headerRowStyle"
      @header-contextmenu="headerContextmenu" @sort-change="sortChange" @filter-change="filterChange"
      @current-change="currentChangeHandler" @header-dragend="headerDagend" @expand-change="expandChange"
      :empty-text="emptyText" ref="learunTable" v-if="isShowTable">
      <el-table-column align="center" width="45" v-if="isSortable && isTree" type="">
        <template slot="header">
          <i class="el-icon-sort" />
        </template>
        <template slot-scope="scope">
          <span class="learun-table__drag-handler" style="cursor: pointer" @click="reorder(scope.row)">
            <i class="el-icon-d-caret" />
          </span>
        </template>
      </el-table-column>
      <!-- 拖动排序  -->
      <el-table-column align="center" width="45" v-if="isSortable && !isTree">
        <template slot="header">
          <i class="el-icon-sort" />
        </template>
        <template>
          <span class="learun-table__drag-handler" style="cursor: pointer">
            <i class="el-icon-rank" />
          </span>
        </template>
      </el-table-column>

      <el-table-column v-if="isExpand" :fixed="isFixed" type="expand" v-slot="scope" width="28">
        <slot v-bind="scope" name="table_expand"></slot>
      </el-table-column>
      <!-- <template v-slot:append="scope">
        <slot v-bind="scope" name="append"></slot>
      </template> -->
      <template v-slot:append>
        <!-- 将 c 组件的插槽传递到 A 组件 -->
        <slot name="append"></slot>
      </template>
      <!-- <template slot="append">
        <div>
          <slot name="append"></slot>
        </div>
        
      </template> -->
      <!-- <template solt="append">
        <slot name="append"></slot>
      </template> -->
      <el-table-column
        v-if="isShowNum"
        :label="ShowNumLabel"
        :fixed="isFixed"
        type="index"
        :width="ShowNumWidth"
        :index="indexMethod"
        :align="numAlign"
      >
      </el-table-column>


      <el-table-column v-if="isMultiSelect && !singleSelect" :fixed="isFixed" type="selection" :selectable="selectable"
        width="35" header-align="center"></el-table-column>
      <el-table-column v-if="singleSelect" :fixed="isFixed" label="" width="35">
        <template slot-scope="scope">
          <el-radio v-model="curtRowKey" :label="scope.row[rowKey]">&nbsp;</el-radio>
        </template>
      </el-table-column>

      <template v-for="(item, index) in tableColumns">
        <el-table-column :key="item.prop || index" v-bind="item" :label="$t(item.label)"
          :show-overflow-tooltip="(item.isNotAutoWrap || allNotAutoWrap) ? true : false"
          :fixed="isSortable && !isTree ? false : item.fixed" :sortable="sortable || item.sortable"
          v-if="!item.children">
          <template v-slot:header="{ column }">
            <slot v-bind="column" :name="`${column.property}_header`">
              <span v-if="isRequired(column.property)" style="color: red">*</span><span>{{ column.label }}</span>
            </slot>
            
          </template>
          <template v-slot="slotProps">
            <slot v-bind="slotProps" :name="item.prop">{{
              columnText(slotProps.$index, slotProps.row, item, slotProps)
              }}</slot>
          </template>
        </el-table-column>
        <dynamic-column v-else :columnOption="item" :columnText="columnText" :isRequired="isRequired" :key="index"
          :label="$t(item.label)" :showOverflowTooltip="item.isNotAutoWrap == true ? true : false"
          :fixed="isSortable && !isTree ? false : item.fixed" :sortable="sortable" :allProps="item.props">
          <template v-for="myProp in item.props || []" v-slot:[myProp]="scope">
            <slot v-bind="scope" :name="myProp"></slot>
          </template>
          <template v-for="myProp in item.props || []" v-slot:[`${myProp}_header`]="{ column }">
            <slot v-bind="column" :name="`${myProp}_header`"></slot>
          </template>
        </dynamic-column>
      </template>
      <slot></slot>
    </el-table>
    <div v-if="isPage" class="l-table--pagination">
      <el-pagination small background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage" :page-sizes="pageSizes || [20, 50, 100, 200]" :page-size.sync="pageSize2"
        :layout="pageLayout" :total="pageTotal">
      </el-pagination>
    </div>
    <l-drawer :title="$t('表格列设置')" :visible.sync="columnsVisible" :showOk="false" :showClose="false"
      :wrapperClosable="true" :modal="false" size="320px" @opened="columnsSettingOpened">
      <el-tree ref="columnsTree" node-key="_id" show-checkbox :data="treeColumns" @check="handleColumnsCheck" draggable
        :allow-drop="allowDrop" @node-drop="handleDrop">
      </el-tree>
    </l-drawer>
  </div>
</template>
<script>
import tableEvent from "@util/tableEvent";
import dynamicColumn from "./dynamic-column";
import { get } from 'lodash'
// 事件： sortable-change(表格行排序变更触发)
export default {
  name: "l-table",
  mixins: [tableEvent()],
  components: {
    dynamicColumn,
  },
  props: {
    allNotAutoWrap: {
      type: Boolean,
      default: false,
    },
    pageLayout: {
      default: 'total, sizes, prev, pager, next, jumper'
    },
    disabeledList: {
      default: ''
    },
    columns: {
      type: Array,
      default: () => [],
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [String, Number],
      default: "100%",
    },
    maxHeight: {
      type: [String, Number],
    },
    stripe: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: true,
    },
    fit: {
      type: Boolean,
      default: true,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    highlightCurrentRow: {
      type: Boolean,
      default: true,
    },

    currentRowKey: [String, Number],
    rowKey: [String, Function],

    rowClassName: [String, Function],
    cellClassName: [String, Function],
    headerRowClassName: [String, Function],
    headerCellClassName: [String, Function],

    defaultExpandAll: Boolean,
    expandRowKeys: {
      type: Array,
    },

    defaultSort: Object,

    tooltipEffect: String,

    showSummary: {
      type: Boolean,
      default: false,
    },
    sumText: {
      type: String,
      default: "合计",
    },
    summaryMethod: Function,

    spanMethod: Function,

    selectOnIndeterminate: {
      type: Boolean,
      default: true,
    },

    indent: {
      type: Number,
      default: 16,
    },
    lazy: Boolean,
    load: Function,
    treeProps: Object,

    isPage: {
      type: Boolean,
      default: false,
    },
    pageSizes: Array,
    pageTotal: {
      type: Number,
      default: 0,
    },
    tablePage: {
      type: Number,
      default: 1,
    },

    isShowNum: {
      type: Boolean,
      default: true,
    },
    ShowNumLabel: {
      type: String,
      default: "序号",
    },
    ShowNumWidth: {
      type: [String, Number],
      default: "55",
    },
    numAlign: {
      type: String,
      default: "",
    },
    isMultiSelect: Boolean,
    reserveSelection: {
      type: Boolean,
      default: true,
    },

    isTree: {
      type: Boolean,
      default: false,
    },
    pidKey: {
      type: String,
    },
    selectKey: String,
    sortable: {
      default: false,
    },
    isSortable: {
      type: Boolean,
      default: false,
    },

    isExpand: {
      type: Boolean,
      default: false,
    },
    isChild: {
      type: Boolean,
      default: false,
    },
    rowStyle: [Function, Object],
    cellStyle: [Function, Object],
    headerRowStyle: [Function, Object],
    headerCellStyle: [Function, Object],
    pageSize: {
      type: Number,
      default: 50,
    },
    required: {
      type: Boolean,
      default: false,
    },
    tid: {
      type: String,
      default: "",
    },
    showColumns: {
      default: () => {
        return []
      }
    },
    singleSelect: {
      default: false
    },
    size: {
      default: 'mini'
    },
    emptyText: {
      default: '暂无数据'
    },
    cellEmptyText: {
      default: ''
    },
    cancelColumn: {
      default: true
    },
    requiredTip: {
      default: ''
    }
  },
  data() {
    return {
      selectedData: [],
      columnsVisible: false,
      columnsChecks: [],
      pageSize3: 0,
      isShowTable: true,
      curtRowKey: '',
      emptyHeight: 0
    };
  },
  beforeDestroy() {
    this.dragSortable && this.dragSortable.destroy() && (this.dragSortable = null);
  },
  created() {
    if (!this.tid || !this.loginInfo.f_UserId) return
    let tableConfig = window.$getStore({ name: 'tableConfig' }) || {},
      mayConfig = tableConfig[this.loginInfo.f_UserId]
    if (!mayConfig) mayConfig = tableConfig[this.loginInfo.f_UserId] = {}
    if (mayConfig[this.tid]) this.columnsChecks = mayConfig[this.tid]
  },
  mounted() {
    this.curtRowKey = this.currentRowKey
    this.setSort();
    if (this.isChild) {
      let list = this.$el.querySelectorAll(".el-table__row");
      list.forEach((row) => {
        row.classList.add("el-table__row2");
        row.classList.remove("el-table__row");
      });
      list = null
    }
  },
  computed: {
    pageSize2: {
      get() {
        if (this.pageSize3 != 0) {
          return this.pageSize3;
        }
        return this.pageSize;
      },
      set(val) {
        this.pageSize3 = val;
        this.$emit("update:pageSize", val);
      },
    },
    isFixed() {
      return (
        this.columns.find((item) => {
          return item.fixed == true;
        }) != undefined && !this.isSortable
      );
    },
    tableHeight() {
      if (this.height == "notset" || this.isChild) {
        return;
      } else {
        return "100%";
      }
    },
    tableHeight2() {
      if (this.height == "notset" || this.isChild) {
        return;
      } else {
        return this.height;
      }
    },
    currentPage: {
      get() {
        if (!this.$validatenull(this.tablePage)) {
          return this.tablePage;
        } else {
          return 1;
        }
      },
      set(val) {
        this.$emit("update:tablePage", val);
      },
    },
    tableShowData() {
      if (this.isTree) {
        return this.$toTree(
          this.dataSource,
          this.multiSelectKey,
          this.pidKey,
          this.multiSelectKey,
          this.multiSelectKey
        );
      } else {
        return this.dataSource;
      }
    },
    multiSelectKey() {
      if (this.selectKey) {
        return this.selectKey;
      } else if (typeof this.rowKey == "string") {
        return this.rowKey;
      } else {
        return this.selectKey;
      }
    },
    selectedValues() {
      return this.selectedData.map((t) => t[this.multiSelectKey]);
    },

    arrayColumns() {
      // 列的数据结构是树形结构，方便处理需要转成数组结构
      return this.$toArray(this.columns);
    },
    treeColumns() {
      // 列的数据结构是树形结构，方便处理需要转成数组结构
      return this.$toTree(this.$deepClone(this.arrayColumns));
    },
    tableColumns() {
      if (this.columns.length == 0) {
        if (this.cancelColumn) {
          return [{ label: "", prop: "learun_null", minWidth: "1" }];
        } else {
          return []
        }
      }

      let res;
      if (this.columnsChecks.length) {
        res = this.arrayColumns.filter(
          (t) => this.columnsChecks.indexOf(t._id) != -1
        );
        res = res.sort((a, b) => {
          return this.columnsChecks.indexOf(a.prop) - this.columnsChecks.indexOf(b.prop)
        })
      } else {
        res = this.arrayColumns.filter(
          (t) => this.defaultCheckedKeys.indexOf(t._id) != -1
        );
      }
      if (res.length == 0) {
        return [{ label: "", prop: "learun_null", minWidth: "1" }];
      }
      return this.$toTree(res);
      //return this.columns
    },
    defaultCheckedKeys() {
      return this.arrayColumns
        .filter((t) => t.isNotShow != true)
        .map((t) => t._id);
    },
  },
  watch: {
    currentRowKey(val) {
      this.curtRowKey = val
    },
    showColumns(val) {
      this.columnsChecks = this.showColumns
    },
    dataSource() {
      if (this.isChild) {
        let list = this.$el.querySelectorAll(".el-table__row");
        list.forEach((row) => {
          row.classList.add("el-table__row2");
          row.classList.remove("el-table__row");
        });
        list = null
      }
      this.selectRows();
    },
    columnsChecks(val) {
      if (!this.tid || !this.loginInfo.f_UserId) return
      let tableConfig = window.$getStore({ name: 'tableConfig' }) || {},
        mayConfig = tableConfig[this.loginInfo.f_UserId]
      if (!mayConfig) tableConfig[this.loginInfo.f_UserId] = {}
      tableConfig[this.loginInfo.f_UserId][this.tid] = val
      window.$setStore({ name: 'tableConfig', content: tableConfig })
    }
  },
  methods: {
    reorder(row) {
      this.$emit('reorder', row)
    },
    selectable(row) {
      if (!this.rowKey) return true
      let bol = this.disabeledList.indexOf(row[this.rowKey]) == -1
      return bol
    },
    indexMethod(index) {
      if (this.isPage) {
        return (this.currentPage - 1) * this.pageSize2 + index + 1;
      } else {
        return index + 1;
      }
    },
    handleSizeChange(val) {
      this.pageSize2 = val;
      this.$emit("loadPageData", { rows: val, page: this.currentPage });
      //console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.$emit("loadPageData", { rows: this.pageSize2, page: val });
    },
    doLayout() {
      // this.emptyHeight = this.$refs.learunTable.$el.clientHeight + 'px'
      // this.$nextTick(() => {
      //   this.isShowTable = false;
      //   this.$nextTick(() => {
      //     this.isShowTable = true;
      //     this.$nextTick(() => {
      //       this.emptyHeight = 0
      //     })
      //   });
      // })
      this.isShowTable = false;
      this.$nextTick(() => {
        this.isShowTable = true;
      });
    },

    // 关于多选
    reset() {
      this.selectedData = [];
      this.$refs.learunTable.clearSelection();
    },
    getSelected() {
      return this.$deepClone(this.selectedData);
    },
    handleSelect(selection, row) {
      if (!this.reserveSelection) {
        this.$emit("select", selection, row);
        return;
      }
      // 获取增加项
      const addList = selection.filter(
        (t) => this.selectedValues.indexOf(t[this.multiSelectKey]) == -1
      );
      if (addList.length > 0) {
        this.selectedData = addList.concat(this.selectedData);
      } else {
        // 获取当前页面没有被选中的
        let notSelectedList = this.dataSource.filter(
          (t) =>
            selection.findIndex(
              (t2) => t2[this.multiSelectKey] == t[this.multiSelectKey]
            ) == -1
        );
        // 获取减少项
        let deleteList = notSelectedList.filter(
          (t) => this.selectedValues.indexOf(t[this.multiSelectKey]) != -1
        );
        this.selectedData = this.selectedData.filter(
          (t) =>
            deleteList.findIndex(
              (t2) => t2[this.multiSelectKey] == t[this.multiSelectKey]
            ) == -1
        );
      }
      if (row && row.children && row.children.length > 0) {
        var ite = selection.find(x => x[this.rowKey] == row[this.rowKey])
        if (ite) {
          this.recursiveCheck(row.children, true);
        } else {
          this.recursiveCheck(row.children, false);
        }
      } else {
        // // 如果是子节点被改变，根据父节点的状态同步子节点的状态
        // const parent = this.findParent(row[this.pidKey]);
        // if (parent) {
        //   this.$refs.table.toggleRowSelection(parent, true);
        // }
      }
      this.$emit("select", selection, row);
    },
    findParent(id) {
      // 根据id查找父节点，这里需要你根据实际数据结构实现此方法
      for (const item of this.tableShowData) {
        if (item.children) {
          const found = this.findInChildren(item.children, id);
          if (found) return found;
        }
      }
      return null;
    },
    findInChildren(children, id) {
      for (const child of children) {
        if (child[this.rowKey] === id) return child;
        if (child.children) {
          const found = this.findInChildren(child.children, id);
          if (found) return found;
        }
      }
      return null;
    },
    handleSelectAll(selection) {
      if (this.isTree) {
        if (this.dataSource.length > 0) {
          if (
            this.dataSource.filter(
              (t) => this.selectedValues.indexOf(t[this.multiSelectKey]) != -1
            ).length < this.dataSource.length
          ) {
            let needSelectData = this.dataSource.map(
              (t) => t[this.multiSelectKey]
            );
            this.selectTreeRows2(this.tableShowData, needSelectData);
            this.handleSelect(this.dataSource);
          } else {
            // 表示全部不选中
            this.$refs.learunTable.clearSelection();
            this.handleSelect([]);
          }
        }
      } else {
        this.handleSelect(selection);
      }
      this.$emit("selectAll", selection);
    },
    recursiveCheck(children, checked) {
      children.forEach(child => {
        this.$refs.learunTable.toggleRowSelection(child, checked);
        if (child.children && child.children.length > 0) {
          this.recursiveCheck(child.children, checked); // 递归处理孙子节点
        }
      });
    },
    selectRows() {
      if (!this.isMultiSelect || !this.reserveSelection) {
        return;
      }
      this.$nextTick(() => {
        if (this.isTree) {
          this.selectTreeRows(this.tableShowData);
        } else {
          this.dataSource.forEach((row) => {
            if (this.selectedValues.indexOf(row[this.multiSelectKey]) != -1) {
              this.$refs.learunTable.toggleRowSelection(row, true);
            }
          });
        }
      });
    },
    selectTreeRows(data) {
      data.forEach((row) => {
        if (this.selectedValues.indexOf(row.value) != -1) {
          this.$refs.learunTable.toggleRowSelection(row, true);
        }
        if (row.children) {
          this.selectTreeRows(row.children);
        }
      });
    },
    selectTreeRows2(data, selectValues) {
      data.forEach((row) => {
        if (selectValues.indexOf(row.value) != -1) {
          this.$refs.learunTable.toggleRowSelection(row, true);
        }
        if (row && row.children) {
          this.selectTreeRows2(row.children, selectValues);
        }
      });
    },

    // 动态显示列
    openColumnsSetting() {
      this.columnsVisible = true;
    },
    columnsSettingOpened() {
      let checks = this.columnsChecks.length ? this.columnsChecks : this.defaultCheckedKeys;
      checks = checks.filter(
        (t) =>
          this.arrayColumns.findIndex((t2) => t2._id == t && t2._hasChildren) ==
          -1
      );
      this.columnsChecks = checks
      this.$refs.columnsTree.setCheckedKeys(this.columnsChecks);
    },
    handleColumnsCheck($node, data) {
      this.columnsChecks = data.checkedKeys.concat(data.halfCheckedKeys);
      this.$emit('columnsChecksChange', this.columnsChecks)
      this.doLayout();
    },

    // 行排序(暂时不支持树形结构)
    setSort() {
      const callback = () => {
        let el = this.$refs.learunTable.$el.querySelectorAll(
          ".el-table__body-wrapper > table > tbody"
        )[0];
        this.dragSortable = window.Sortable.create(el, {
          ghostClass: "learun-table__sortable",
          handle: ".learun-table__drag-handler",
          onEnd: (evt) => {
            const oldindex = evt.oldIndex;
            const newindex = evt.newIndex;
            const targetRow = this.dataSource.splice(oldindex, 1)[0];
            this.dataSource.splice(newindex, 0, targetRow);
            this.$emit(
              "sortable-change",
              oldindex,
              newindex,
              targetRow,
              this.dataSource
            );
          },
        });
        el = null
      };
      if (this.isSortable && !this.isTree) {
        this.$nextTick(() => {
          callback();
        });
      }
    },

    columnText(index, row, column, scope) {
      if (typeof column.formatter == "function") {
        return column.formatter({
          row: row,
          column: scope.column,
          cellValue: get(row, column.prop, ''),
          index: index,
        });
      } else {
        this.loadCellData(get(row, column.prop, ''), column);
        return this.getCellText(get(row, column.prop, ''), column);
      }
    },
    loadCellData(value, { dataType, dataCode, ParamJsonList }) {
      if (dataType && value) {
        switch (dataType) {
          case "dataItem":
            this.lr_loadDataItem && this.lr_loadDataItem(dataCode);
            break;
          case "dataSource":
            if (ParamJsonList) {
              var obj = {}
                ParamJsonList.forEach(item => {
                  let key = item.f_ParamName.slice(1)
                  if (this.lr_dataParamsSource[item.f_DefaultValue]) {
                    obj[key] = this.lr_dataParamsSource[item.f_DefaultValue]
                  } else {
                    if((item.f_DataType == 'date' || item.f_DataType == 'datetime') && item.f_NewDefaultValue){
                      obj[key] = item.f_NewDefaultValue
                    }else if (item.f_DefaultValue) {
                      obj[key] = item.f_DefaultValue
                    }
                  }
                })
                let pamdata = {
                  queryJson: obj
                }
                // let key = `${dataCode}_${JSON.stringify(pamdata)}`
                this.lr_loadDataSourceDataByParamter(dataCode,pamdata, true, true)
            } else {
              this.lr_loadDataSourceData && this.lr_loadDataSourceData(dataCode);
            }
            break;
          case "company":
            this.lr_loadCompanys && this.lr_loadCompanys();
            break;
          case "department":
            this.lr_loadDepartment && this.lr_loadDepartment(value);
            break;
          case "role":
            this.lr_loadRole && this.lr_loadRole(value);
            break;
          case "post":
            this.lr_loadPost && this.lr_loadPost(value);
            break;
          case "user":
            this.lr_loadUsers && this.lr_loadUsers(value);
            break;
          case "areas":
            if (this.lr_loadAreas) {
              const areaList = value.split(",");
              if (areaList.length == 3) {
                this.lr_loadAreas(0),
                  this.lr_loadAreas(areaList[0]),
                  this.lr_loadAreas(areaList[1]);
              }
            }
            break;
        }
      }
    },
    getCellText(
      value,
      { dataType, dataCode, options, valueKey, labelKey, format }
    ) {
      if (window.$validatenull(value)) {
        return "" || this.cellEmptyText;
      }
      if (!this.lr_dataSourceName) {
        return value;
      }
      switch (dataType) {
        case "mydata": {
          const dataSource = [];
          this.findTreeItem(options, dataSource); //静态数据
          return this.lr_dataSourceName(
            dataSource,
            value,
            "value",
            "label",
            this.$uuid()
          );
        }
        case "dataItem":
          return this.lr_dataItemName(this.lr_dataItem[dataCode], value);
        case "dataSource":
          return this.lr_dataSourceName2(dataCode, value, valueKey, labelKey);
        case "datetime":
          return window.$formatDate(value, format || "yyyy-MM-dd hh:mm:ss");
        case "company":
          return this.lr_loadCompanyName(value);
        case "department":
          return this.lr_departmentNameByOne(value);
        case "role":
          return (this.lr_role[value] || {})[labelKey || "f_FullName"] || "";
        case "post":
          return (this.lr_post[value] || {})[labelKey || "f_FullName"] || "";
        case "user":
          return this.lr_userName(value);
        case "areas":
          return this.lr_areasName(value);
        case "money":
          return this.showMoney(value);
        default:
          if (dataType && dataType.indexOf('{val}') > -1) {
            return dataType.replace(/{val}/g, value)
          }
          return value;
      }
    },
    findTreeItem(arr, res) {
      arr.forEach((t) => {
        res.push({ value: t.value, label: t.label });
        if (t.children) {
          this.findTreeItem(t.children, res);
        }
      });
    },

    getSummaries(param) {
      this.$nextTick(() => {
        this.$refs.learunTable.doLayout();
      });

      if (this.summaryMethod) {
        return this.summaryMethod(param);
      }

      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.sumText;
          return;
        }

        const myColumn = this.arrayColumns.find(
          (t) => t.prop == column.property
        );
        function getDecimalPlaces(num) {
          const str = num.toString();
          if (str.indexOf('.') !== -1) {
            return str.split('.')[1].length;
          }
          return 0;
        }
        if (myColumn && myColumn.isSummary) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            let maxFix = 0
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                let fix = Math.max(getDecimalPlaces(prev), getDecimalPlaces(curr));
                if (fix > 0) {
                  if (fix > maxFix) maxFix = fix
                  prev = prev*10**fix, curr = curr*10**fix
                  return (((prev + curr) / (10**fix)).toFixed(maxFix))*1;
                }
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = (sums[index].toFixed(maxFix))*1
            //sums[index] += ' 元';
          } else {
            sums[index] = "N/A";
          }
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    isRequired(property) {
      let myColumn = this.columns.find((t) => t.prop == property);
      if (!myColumn) {
        return false;
      }
      return myColumn.required;
    },
    validate() {
      let res = true;
      if (this.required) {
        if (this.dataSource.length == 0) {
          this.$message({
            type: "error",
            message: this.$t(this.requiredTip || `请添加表格数据`),
          });
          return false;
        }
      }
      try {
        this.dataSource.forEach((row, index) => {
          this.columns.forEach((col) => {
            if (!col.isHidden) {
              if (col.required && this.$validatenull(row[col.prop])) {
                this.$message({
                  type: "error",
                  message: this.$t(`请输入第${index + 1}行-${col.label}`),
                });
                res = false;
                throw new Error();
              }

              if (col.patterns && col.patterns.length > 0) {
                col.patterns.forEach((pattern) => {
                  if (
                    pattern.reg &&
                    !this.$validatenull(row[col.prop]) &&
                    !new RegExp(
                      pattern.reg.substring(1, pattern.reg.length - 1)
                    ).test(row[col.prop])
                  ) {
                    this.$message({
                      type: "error",
                      message: this.$t(
                        `${pattern.msg}第${index + 1}行-${col.label}`
                      ),
                    });
                    res = false;
                    throw new Error();
                  }
                });
              }
            }
          });
        });
      } catch (error) { }
      return res;
    },
    allowDrop(draggingNode, dropNode, type) {
      return type === "prev" || type === "next";
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      // 拖拽之后会改变选中，再次默认选中
      this.setCheckedKeys();
    },
    //自定义选中方法
    setCheckedKeys() {
      // 确保数据渲染到tree之后再做checked
      setTimeout(() => {

        this.$refs.columnsTree.setCheckedKeys(this.columnsChecks);
        let arr = this.treeColumns.map(e => e._id),
          brr = this.columnsChecks.sort((a, b) => {
            return arr.indexOf(a) - arr.indexOf(b)
          })
        this.columnsChecks = this.$deepClone(brr)
        this.$emit('columnsChecksChange', this.columnsChecks)
        this.doLayout();
        this.$forceUpdate();
      }, 100);
    },
    currentChangeHandler(currentRow, oldCurrentRow) {// 当表格的当前行发生变化的时候会触发该事件，如果要高亮当前行，请打开表格的 highlight-current-row 属性
      this.curtRowKey = currentRow[this.rowKey]
      this.$emit('update:currentRowKey', currentRow[this.rowKey])
      this.currentChange(currentRow, oldCurrentRow)
    },
  },
};
</script>
<style lang="less">
@import "./index.less";
</style>
